class EditForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.birth = this.querySelector('#MyAccount-dob');

        // Checkbox references
        this.privacyConsentCheckbox = this.querySelector('#privacy_consent');
        this.marketingConsentCheckbox = this.querySelector('#marketing_consent');
        this.profilingConsentCheckbox = this.querySelector('#profiling_consent');

        // Birthday settings from data attributes
        this.birthdayContainer = this.querySelector('#birth-date-container');
        this.enableBirthdayValidation = this.birthdayContainer?.dataset.enableBirthdayValidation === 'true';
        this.minimumAgeRequired = parseInt(this.birthdayContainer?.dataset.minimumAgeRequired) || 18;

        // Event listener for birth date
        this.birth.addEventListener("change", this.onChange.bind(this));

        // Event listeners for checkboxes
        if (this.privacyConsentCheckbox) {
            this.privacyConsentCheckbox.addEventListener("change", this.onChange.bind(this));
        }
        if (this.marketingConsentCheckbox) {
            this.marketingConsentCheckbox.addEventListener("change", this.onChange.bind(this));
        }
        if (this.profilingConsentCheckbox) {
            this.profilingConsentCheckbox.addEventListener("change", this.onChange.bind(this));
        }

        // Set max birth date to 18 years ago
        this.setMaxBirthDate();
    }

    connectedCallback() {
        this.setBirth(this.birth.value);
        this.setTags();
    }

    setMaxBirthDate() {
        // Only set max date if birthday validation is enabled
        if (!this.enableBirthdayValidation) {
            return;
        }

        const today = new Date();
        const year = today.getFullYear() - this.minimumAgeRequired;
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const maxDate = `${year}-${month}-${day}`;
        this.birth.max = maxDate;
    }

    setBirth(birth) {
        this.birth_value = birth;
    }

    setConsents() {
        this.privacy_consent = this.privacyConsentCheckbox ? this.privacyConsentCheckbox.checked : true;
        this.marketing_consent = this.marketingConsentCheckbox ? this.marketingConsentCheckbox.checked : true;
        this.profiling_consent = this.profilingConsentCheckbox ? this.profilingConsentCheckbox.checked : true;
    }

    setTags() {
        this.setConsents();

        let tags = ``;
        tags += `privacy_consent:${this.privacy_consent}`;
        tags += `,marketing_consent:${this.marketing_consent}`;
        tags += `,profiling_consent:${this.profiling_consent}`;
        if (this.birth_value !== "") {
            tags += `,birth:${this.birth_value}`;
        }

        this.form.querySelector('#tags_value').value = tags;
    }

    onChange(e) {
        if (e.target.isSameNode(this.birth)) {
            this.setBirth(e.target.value);
        }
        this.setTags();
    }
}

customElements.define("edit-form", EditForm);


// class EditFormNewsletter extends EditForm {
//     constructor() {
//         super();
//     }

//     connectedCallback() {
//         super.connectedCallback();
//     }

//     submitCustomerForm() {
//         this.form.addEventListener('submit', (e) => {
//             e.preventDefault();
//             console.log("submitting form");
//             const customerData = {
//                 first_name: this.form.querySelector('first_name').value,
//                 last_name: this.form.querySelector('last_name').value,
//                 phone: this.phone_value,
//                 email: this.form.querySelector('email').value,
//                 accepts_marketing: this.form.querySelector('#accepts_marketing').value,
//                 accepts_marketing_sms: true
//             };
//             fetch('/customers.json', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify(customerData)
//             }).then(response => {
//                 if (response.ok) {
//                     return response.json();
//                 }
//                 throw new Error('Network response was not ok.');
//             }).then(jsonResponse => {
//                 console.log(jsonResponse);
//             }).catch(error => {
//                 console.log('There has been a problem with your fetch operation:', error);
//             });
//         });
//     }
// }

// customElements.define("edit-form-newsletter", EditFormNewsletter);